import { shipmentApiClient } from '../shipmentApiClient'
import { updateShipmentStatusEndpoint } from './endpoint'
import type { UpdateShipmentStatusParams } from './type'

export const updateShipmentStatus = async (params: UpdateShipmentStatusParams): Promise<void> => {
  await shipmentApiClient.post(updateShipmentStatusEndpoint(params.shipmentUid), {
    deliveryReportUid: params.deliveryReportUid,
    status: params.status,
  })
}
